export const PARTICULAR = "Particular";
export const COMERCIAL = "Comercial";

// Las aseguradoras solo distinguen entre uso particular y comercial. Los usos
// granulares del selector son una distinción de interfaz: cualquiera de ellos
// se cotiza como comercial y habilita el step de condición fiscal.
export const esUsoComercial = (uso?: string | null): boolean =>
  Boolean(uso) && uso !== PARTICULAR;
